import { SidebarFeatureEnum } from 'config/types/sidebar'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { lazy, Suspense } from 'react'
import { BoxProps } from 'UIKit/Box/types'
import { buildSidebarTitle } from '../utils'

const MobileHeader = lazy(() => import('./SidebarMobileHeader'))
const DesktopHeader = lazy(() => import('./SideBarDesktopHeader'))

type SideBarHeaderProps = {
  feature: SidebarFeatureEnum
  onClose: () => void
  containerRef?: React.RefObject<HTMLDivElement>
} & BoxProps

const SideBarHeader: React.FC<SideBarHeaderProps> = ({ feature, onClose, containerRef, ...props }) => {
  const { isMobile } = useMatchBreakpoints()

  const title = buildSidebarTitle(feature)

  return (
    <Suspense fallback={null}>
      {isMobile ? (
        <MobileHeader title={title} onClose={onClose} containerRef={containerRef} {...props} />
      ) : (
        <DesktopHeader title={title} onClose={onClose} {...props} />
      )}
    </Suspense>
  )
}

export default SideBarHeader
